/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const FileTreatments = core.serialization.enum_(["IS_BASIC_FILE_SHAPE", "IS_COMPLEX_FILE_SHAPE"]);
